import { useEffect, useRef, useState } from 'react';
import { ImagePlus, X } from 'lucide-react';

export function assetImageError(file: File): string {
  if (!/\.(png|jpe?g|webp|gif)$/i.test(file.name)) return 'Выберите картинку JPG, PNG, WebP или GIF.';
  if (!file.size || file.size > 20 * 1024 * 1024) return 'Изображение должно быть не больше 20 МБ.';
  return '';
}

export function AssetImageInput({ file, path, disabled, onFile, onPath }: { file: File | null; path: string; disabled: boolean; onFile: (file: File | null) => void; onPath: (path: string) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const [url, setUrl] = useState(''), [drag, setDrag] = useState(false);
  useEffect(() => {
    if (!file) return;
    const next = URL.createObjectURL(file); setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);
  return <section className="sc-asset-image" aria-label="Картинка ассета">
    <label>Картинка ассета — сетевой путь<input value={path} disabled={disabled} onChange={e => onPath(e.target.value)} maxLength={2000} placeholder="\\server03\prj\Проект\_pics\shot.png"/></label>
    <div className={`sc-image-drop${drag ? ' is-dragging' : ''}`} onDragOver={e => { if (e.dataTransfer.types.includes('Files')) { e.preventDefault(); if (!disabled) setDrag(true); } }} onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setDrag(false); }} onDrop={e => { e.preventDefault(); setDrag(false); if (!disabled && e.dataTransfer.files[0]) onFile(e.dataTransfer.files[0]); }}>
      <button type="button" className="sc-image-choose" disabled={disabled} onClick={() => input.current?.click()}>
        {file && url ? <img src={url} alt="Превью выбранной картинки"/> : <ImagePlus size={28}/>}
        <span><strong>{file ? file.name : 'Выбрать картинку'}</strong><small>{file ? 'Будет картинкой нового ассета' : 'Перетащите сюда или вставьте Ctrl+V'}<br/>JPG, PNG, WebP, GIF · до 20 МБ</small></span>
      </button>
      {file && <button type="button" disabled={disabled} aria-label="Убрать выбранную картинку" onClick={() => onFile(null)}><X size={17}/></button>}
      <input hidden type="file" ref={input} accept="image/jpeg,image/png,image/webp,image/gif" disabled={disabled} onChange={e => { if (e.target.files?.[0]) onFile(e.target.files[0]); e.target.value = ''; }}/>
    </div>
  </section>;
}
